import type { FC } from "react";

import styles from "./PointsProgressBar.module.scss";

export type PointsProgressBarProps = {
  currentPoints: number;
  requiredPoints: number;
  pointsNeededText?: string;
  hidden?: boolean;
  className?: string;
};

export const PointsProgressBar: FC<PointsProgressBarProps> = ({
  currentPoints,
  requiredPoints,
  hidden,
  pointsNeededText,
  className,
}) => {
  const progress = Math.min((currentPoints / requiredPoints) * 100, 100);
  const MAX_PROGRESS = 100;
  const neededPoints = requiredPoints - currentPoints;
  if (progress === MAX_PROGRESS || hidden) return null;
  return (
    <div className={`${className} ${styles.pointsProgressBarWrapper}`}>
      {pointsNeededText && (
        <div className={styles.pointsNeeded}>
          {pointsNeededText}
          <div className={styles.pointsNeededValue}>{neededPoints}</div>
        </div>
      )}
      <div className={styles.pointsProgressBar} data-testid={"pointsProgressBar"}>
        <div
          className={styles.pointsProgressBarFill}
          style={{ width: `${progress}%` }}
          data-testid={"pointsProgressBarFill"}
        ></div>
      </div>
    </div>
  );
};
